<template>
  <div class="bulk-selection-bar__actions d-flex align-center">
    <button
      v-for="action in actions"
      :key="action.id"
      type="button"
      class="bulk-selection-bar__action"
      :disabled="loading || action.disabled"
      :data-testid="action.testId || `${testIdPrefix}__bulk-action--${action.id}`"
      @click="$emit('action', action.id)"
    >
      <v-icon
        v-if="action.icon"
        small
        class="bulk-selection-bar__action-icon"
      >
        {{ action.icon }}
      </v-icon>
      <img
        v-else-if="action.iconSrc"
        :src="action.iconSrc"
        :alt="action.iconAlt || ''"
        class="bulk-selection-bar__action-icon-image"
        :class="{ 'bulk-selection-bar__action-icon-image--invert': action.iconInvert }"
        :width="action.iconWidth || 24"
        :height="action.iconHeight || 24"
      />
      <span
        :data-testid="action.labelTestId || `${testIdPrefix}__bulk-action-label--${action.id}`"
      >
        {{ action.label }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BulkSelectionBarActions',
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    testIdPrefix: {
      type: String,
      default: 'bulk-selection-bar',
    },
  },
};
</script>
